import { Component, inject, Input, AfterViewInit } from '@angular/core';
import { TopMediaInfoService } from '../../top-media-info/top-media-info.service';
import { SubsectionService } from '../../../services/subsection.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'viewer-slider-toggle-button',
  templateUrl: './viewer-slider-toggle-button.component.html',
  styleUrl: './viewer-slider-toggle-button.component.scss',
  standalone: false,
})
export class ViewerSliderToggleButtonComponent implements AfterViewInit {
  @Input() typeId: string;

  private readonly topMediaInfoService: TopMediaInfoService = inject(TopMediaInfoService);
  private readonly subsectionService: SubsectionService = inject(SubsectionService);
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  isPdfSliderCollapsed: boolean = false;

  get hasPagedDoc(): boolean {
    const activeFile: any = this.subsectionService.subsectionState?.activeFile;
    return activeFile?.hasPage === true && activeFile?.id === this.typeId;
  }

  ngAfterViewInit(): void {
    this.topMediaInfoService
      .state$()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state) => {
        this.isPdfSliderCollapsed = state?.isPdfSliderCollapsed ?? false;
      });
  }

  public togglePdfSlider(): void {
    if (!this.hasPagedDoc) return;
    this.topMediaInfoService.togglePdfSliderCollapsed();
  }
}
